import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Step3EmploymentDetailsForm } from '../../../../../types/v4/personal-individual-steps';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule, MatError } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SharedModuleV4 } from '../../../../../shared/sharedv4.module';
import { FormButtonGroupSimpleComponent } from '../../../../shared/form-button-group-simple/form-button-group-simple.component';
import { FormFieldDateComponent } from '../../../../shared/form-field-date/form-field-date.component';
import { FormFieldNumericComponent } from '../../../../shared/form-field-numeric/form-field-numeric.component';
import { FormFieldCurrencyComponent } from '../../../../shared/form-field-currency/form-field-currency.component';
import { FormFieldSelectComponent, SelectListType } from '../../../../shared/form-field-select/form-field-select.component';
import { FormFieldComponent } from '../../../../shared/form-field/form-field.component';
import { EmploymentBasis } from '../../../../../api/v4/models/CommonUtilities/employment-basis';
import { UserAction } from '../../../../../api/v4/models/CommonUtilities/user-action';
import { EmploymentStatus } from '../../../../../api/v4/models/Models/v4/Application/EmploymentDetails/employment-status';
import { OnInit } from '@angular/core';
import { EmploymentStatusEnum } from '../../../../../api/v4/models/Models/v3/Application/EmploymentDetails/employment-status-enum';
import { BaseStepComponent } from '../../base-step/base-step.component';
import { FormFieldSelectGroupedComponent } from '../../../../shared/form-field-select-grouped/form-field-select-grouped.component';

@Component({
  selector: 'app-employment-basis',
  host: { 'data-version': 'v4pf' },
  standalone: true,
  imports: [
    CommonModule,
    SharedModuleV4,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatButtonToggleModule,
    FormFieldComponent,
    FormFieldNumericComponent,
    FormFieldCurrencyComponent,
    MatSlideToggleModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatButtonToggleGroup,
    MatError,
    MatSelectModule,
    MatOptionModule,
    FormFieldDateComponent,
    FormButtonGroupSimpleComponent,
    FormFieldSelectComponent,
    MatIconModule,
    FormFieldSelectGroupedComponent
  ],
  templateUrl: './employment-basis.component.html',
  styleUrl: './employment-basis.component.scss'
})
export class EmploymentBasisComponent extends BaseStepComponent {
  @Input() fg!: FormGroup<Step3EmploymentDetailsForm>;
  @Input() formSubmitted!: boolean;

  EmploymentStatus = EmploymentStatus;
  EmploymentBasis = EmploymentBasis;
  UserAction = UserAction;
  SelectListType = SelectListType;

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.fg && this.fg.controls.employmentStatus && this.fg.controls.employmentBasis) {

      this.subscriptions.push(
        this.fg.controls.employmentStatus.valueChanges.subscribe((status: EmploymentStatus | null) => {
          if (status === EmploymentStatus.SelfEmployed) {
            const allowed = [null, EmploymentBasis.FullTime, EmploymentBasis.PartTime];
            const basis = this.fg.controls.employmentBasis.value;
            if (!allowed.includes(basis)) {
              this.fg.controls.employmentBasis.setValue(null);
            }
          }
        }));
    }
  }
}








